// Named separately so deferred quickView.js (products elasticService) cannot overwrite homepage methods.
storefrontApp.service('homepageElasticService', function () {
    // Reusable constants (exposed for controllers that pass includes into batch requests)
    var includesDefault = ["brand", "catalog", "name", "listPrice", "salePrice", "clubPrice", "itemId", "variants", "isBuyable", "definitionName", "saleRank"];
    var includesWithRating = includesDefault.concat(["rating", "description"]);
    var includesWithClubOnly = includesDefault.concat(["isClubOnly"]);
    this.includesDefault = includesDefault;
    this.includesWithRating = includesWithRating;
    this.includesWithClubOnly = includesWithClubOnly;

    // Helper function to build top hits aggregation
    function buildTopHitsAgg(sortField, sortOrder, size, includes) {
        var topHits = {
            top_hits: {
                sort: [{}],
                size: size,
                _source: {
                    includes: includes
                }
            }
        };
        topHits.top_hits.sort[0][sortField] = { order: sortOrder };
        return topHits;
    }

    // Helper function to build term aggregation with sub-aggregation
    function buildAggs(aggName, sortField, sortOrder, size, includes) {
        var aggs = {};
            aggs[aggName] = {
                terms: { field: "definitionName" },
                aggs: {}
            };
        
        aggs[aggName].aggs[aggName] = buildTopHitsAgg(sortField, sortOrder, size, includes);
        return aggs;
    }

    // Helper function to build bool must query
    function buildBoolMustQuery(terms, ranges) {
        var must = [];
        for (var i = 0; i < terms.length; i++) {
            must.push({ term: terms[i] });
        }
        for (var j = 0; j < ranges.length; j++) {
            must.push({ range: ranges[j] });
        }
        return { bool: { must: must } };
    }

    // Helper function to create a standard Elasticsearch request
    function buildElasticRequest(query, aggs, size) {
        return JSON.stringify({
            query: query,
            size: size,
            aggs: aggs
        });
    }

    // Helper function to create a standard product request
    function buildProductRequest(definitionName, priceConditions, sortField, sortOrder, aggName, includes, size) {
        var terms = [{ definitionName: { value: definitionName } }];

        var query = buildBoolMustQuery(terms, priceConditions);
        return buildElasticRequest(
            query,
            buildAggs(aggName || "new_arrivals", sortField || "yearCreated", sortOrder || "desc", size || 100, includes || includesDefault),
            0
        );
    }

    // New Arrivals request for any product definition
    this.buildNewArrivalsRequest = function (prdDef) {
        return buildProductRequest(
            prdDef,
            [{ listPrice: { gt: 0 } }, { clubPrice: { gt: 0 } }],
            "yearCreated",
            "desc",
            "new_arrivals",
            includesDefault
        );
    };

    // PDF Arrivals request (no club price requirement)
    this.buildNewPDFArrivalsRequest = function (prdDef) {
        return buildProductRequest(
            prdDef,
            [{ listPrice: { gt: 0 } }],
            "yearCreated",
            "desc",
            "new_arrivals",
            includesDefault
        );
    };

    // Trending products request
    this.buildTrendingProductsRequest = function () {
        return buildProductRequest(
            "StockDesign",
            [{ listPrice: { gt: 0 } }, { clubPrice: { gt: 0 } }],
            "saleRank",
            "desc",
            "trending_products",
            includesDefault
        );
    };

    // Free products request
    this.buildFreeProductsRequest = function () {
        return buildProductRequest(
            "StockDesign",
            [{ listPrice: { lte: 0 } }],
            "yearCreated",
            "desc",
            "free_products",
            includesWithClubOnly
        );
    };

    // Product ads request
    this.buildProductAdsRequest = function () {
        return buildProductRequest(
            "Software",
            [{ listPrice: { gt: 0 } }],
            "yearCreated",
            "desc",
            "softwares",
            includesWithRating,
            25
        );
    };

    this.buildProductInfoRequest = function (productId, hasMultiple) {
        if (hasMultiple) {
            var req = {
                query: {
                    terms: {
                        _id: []
                    }
                }
            };
            productId.map(function (m) {
                req.query.terms._id.push(m.toLowerCase());
            });
            return JSON.stringify(req);
        }
        return JSON.stringify({
            query: {
                terms: {
                    _id: [productId]
                }
            }
        });
    };

    this.buildAssociatedItemsRequest = function (associatedItems) {
        return JSON.stringify({
            query: {
                terms: {
                    _id: angular.toJson(associatedItems)
                }
            },
            size: associatedItems.length
        });
    };

    this.buildRelatedDesignItemsRequest = function (productId) {
        return JSON.stringify({
            query: {
                wildcard: {
                    "variants.associatedItemsList": {
                        value: productId.toLowerCase()
                    }
                }
            }
        });
    };
    
    // New method to build a batch request for multiple product definitions
    this.buildBatchProductRequest = function (requestConfig) {
        var aggs = {};
        
        // Process each product category in the batch
        for (var i = 0; i < requestConfig.length; i++) {
            var config = requestConfig[i];
            var aggName = config.aggName || "products_" + i;
            var definitionName = config.definitionName;
            var priceConditions = config.priceConditions || [{ listPrice: { gt: 0 } }, { clubPrice: { gt: 0 } }];
            var sortField = config.sortField || "yearCreated";
            var sortOrder = config.sortOrder || "desc";
            var size = config.size || 100;
            var includes = config.includes || includesDefault;
            
            // Create filter for this product category
            var filterAggs = {};
                    filterAggs[aggName] = {
                        filter: {
                            bool: {
                                must: [
                                    { term: { definitionName: definitionName } }
                                ]
                            }
                        },
                        aggs: {}
                    };
            
            // Add price conditions to the filter
            for (var j = 0; j < priceConditions.length; j++) {
                var conditionKey = Object.keys(priceConditions[j])[0];
                var condition = {};
                condition[conditionKey] = priceConditions[j][conditionKey];
                filterAggs[aggName].filter.bool.must.push({ range: condition });
            }
            
            // Add top hits aggregation
            filterAggs[aggName].aggs[aggName] = buildTopHitsAgg(sortField, sortOrder, size, includes);
            
            // Add to main aggregations
            aggs = Object.assign(aggs, filterAggs);
        }
        
        // Build the complete request
        return JSON.stringify({
            size: 0,
            aggs: aggs
        });
    };
    
    // Helper method to build batch request for new arrivals of multiple product types
    this.buildBatchNewArrivalsRequest = function (productDefinitions) {
        var requestConfig = [];
        
        productDefinitions.forEach(function(prdDef, index) {
            requestConfig.push({
                definitionName: prdDef,
                aggName: "new_arrivals_" + prdDef.replace(/\s+/g, '_').toLowerCase(),
                priceConditions: [{ listPrice: { gt: 0 } }, { clubPrice: { gt: 0 } }],
                sortField: "yearCreated",
                sortOrder: "desc",
                includes: includesDefault
            });
        });
        
        return this.buildBatchProductRequest(requestConfig);
    };
    
    // Helper method to build batch request for PDF arrivals (no club price requirement)
    this.buildBatchPDFArrivalsRequest = function (productDefinitions) {
        var requestConfig = [];
        
        productDefinitions.forEach(function(prdDef, index) {
            requestConfig.push({
                definitionName: prdDef,
                aggName: "pdf_arrivals_" + prdDef.replace(/\s+/g, '_').toLowerCase(),
                priceConditions: [{ listPrice: { gt: 0 } }],
                sortField: "yearCreated",
                sortOrder: "desc",
                includes: includesDefault
            });
        });
        
        return this.buildBatchProductRequest(requestConfig);
    };

    //#region Embrilliance (homepage)
    this.buildEmbrillianceProductsRequest = function (size, definitionNames) {
        size = size || 8;
        definitionNames = definitionNames || ["Software"];

        var must = [
            { term: { brand: "briton leap" } },
            { term: { inStock: true } },
            { range: { listPrice: { gt: 0 } } }
        ];

        if (definitionNames && definitionNames.length > 0) {
            if (definitionNames.length === 1) {
                must.push({ term: { definitionName: definitionNames[0] } });
            } else {
                must.push({
                    bool: {
                        should: definitionNames.map(function (def) {
                            return { term: { definitionName: def } };
                        }),
                        minimum_should_match: 1
                    }
                });
            }
        }

        return JSON.stringify({
            query: { bool: { must: must } },
            size: size,
            sort: [
                { saleRank: { order: "desc" } },
                { rating: { order: "desc" } }
            ],
            _source: {
                includes: [
                    "brand",
                    "catalog",
                    "name",
                    "listPrice",
                    "salePrice",
                    "clubPrice",
                    "itemId",
                    "productId",
                    "variants",
                    "variants.variantId",
                    "variants.variantLabel",
                    "variants.listPrice",
                    "variants.salePrice",
                    "variants.clubPrice",
                    "variants.numberOfDesigns",
                    "variants.fileTypesAvailable",
                    "isBuyable",
                    "definitionName",
                    "rating",
                    "saleRank",
                    "yearCreated",
                    "videoParts",
                    "runTime"
                ]
            }
        });
    };

    this.buildEmbrillianceStarterPacksRequest = function (size, definitionNames) {
        size = size || 6;
        definitionNames = definitionNames || ["ProjectPack", "FontPack", "DesignPack"];

        var must = [
            { term: { "categoriesList.keyword": "embrilliance starter packs" } },
            { term: { inStock: true } },
            { range: { listPrice: { gt: 0 } } }
        ];

        if (definitionNames && definitionNames.length > 0) {
            must.push({
                bool: {
                    should: definitionNames.map(function (def) {
                        return { term: { definitionName: def } };
                    }),
                    minimum_should_match: 1
                }
            });
        }

        return JSON.stringify({
            query: { bool: { must: must } },
            size: size,
            sort: [
                { saleRank: { order: "desc" } },
                { rating: { order: "desc" } }
            ],
            _source: {
                includes: [
                    "brand",
                    "catalog",
                    "name",
                    "listPrice",
                    "salePrice",
                    "clubPrice",
                    "itemId",
                    "productId",
                    "variants",
                    "variants.variantId",
                    "variants.variantLabel",
                    "variants.listPrice",
                    "variants.salePrice",
                    "variants.clubPrice",
                    "variants.numberOfDesigns",
                    "variants.fileTypesAvailable",
                    "isBuyable",
                    "definitionName",
                    "rating",
                    "saleRank",
                    "yearCreated",
                    "videoParts",
                    "runTime",
                    "categoriesList"
                ]
            }
        });
    };
    //#endregion
});
